module.exports = __webpack_public_path__ + "img/csorbics-article-pic.ee27ea85.png";